import React from 'react';
import { Users, BookOpen, Gift, Star } from 'lucide-react';
export function SocialProof() {
  const stats = [{
    icon: <Users className="w-5 h-5 text-violet-400" data-id="element-299" />,
    text: '+1.200 docentes'
  }, {
    icon: <BookOpen className="w-5 h-5 text-violet-400" data-id="element-300" />,
    text: '6 Tomos completos'
  }, {
    icon: <Gift className="w-5 h-5 text-violet-400" data-id="element-301" />,
    text: '4 Bonus incluidos'
  }, {
    icon: <Star className="w-5 h-5 text-violet-400 fill-violet-400" data-id="element-302" />,
    text: '4.9/5 calificación ⭐'
  }];
  return <div className="bg-zinc-900 border-y border-violet-900/40 py-6" data-id="element-303">
      <div className="container mx-auto px-4" data-id="element-304">
        <div className="flex flex-wrap justify-center gap-x-8 gap-y-4 md:justify-between items-center max-w-5xl mx-auto" data-id="element-305">
          {stats.map((stat, i) => <div key={i} className="flex items-center gap-2 font-medium text-zinc-100" data-id="element-306">
              {stat.icon}
              <span data-id="element-307">{stat.text}</span>
            </div>)}
        </div>
      </div>
    </div>;
}